import { SettingsSection } from '@components'

import { Button, Space, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { SettingsRoute } from '../../../../../../enums/settingsRoute'

export const ChartOfAccountsSection = () => {
  const { t } = useTranslation()

  return (
    <SettingsSection>
      <SettingsSection.Content title={t('settings.organization.accounting.chart_of_accounts')}>
        <Text colorVariant="secondary">{t('settings.organization.accounting.chart_of_accounts.subtext')}</Text>
        <Space size="s16" />
        <Button variant="outlined" to={SettingsRoute.OrganizationAccountingChartOfAccounts}>
          {t('settings.organization.accounting.chart_of_accounts.edit')}
        </Button>
      </SettingsSection.Content>
    </SettingsSection>
  )
}
